var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tribe-box-image-text", class: _vm.direction },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass: "col-12 col-xl-6 mb-24 mb-xl-0",
            class: { "order-xl-1": _vm.direction === "image-right" }
          },
          [
            _c("img", {
              staticClass: "w-100 h-auto",
              attrs: {
                src: _vm.tribeBox.acf.image.sizes.medium_large,
                alt: _vm.tribeBox.title.rendered
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 col-xl-6",
            class: { "order-xl-0": _vm.direction === "image-right" }
          },
          [
            _c("div", { staticClass: "content-wrapper" }, [
              _c("h2", {
                staticClass: "mb-16",
                domProps: { innerHTML: _vm._s(_vm.tribeBox.title.rendered) }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "text-dark font-weight-light small mb-24 mb-child-0"
                },
                [
                  _c("show-more", {
                    attrs: { content: _vm.tribeBox.acf.description }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-accent",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.toggleSlideout($event)
                    }
                  }
                },
                [
                  _vm._v("Bestel deze Tribe Box "),
                  _c("span", {
                    staticClass: "arrow-right",
                    domProps: { innerHTML: _vm._s(_vm.svg("arrow-right")) }
                  })
                ]
              )
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }